export default __webpack_public_path__ + "static/media/img_guide_PC.a61aa3a6.png";